import React from "react";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import Divider from "@mui/material/Divider";

interface FooterProps {
  primaryColor?: string;
  accentColor?: string;
  logoUrl?: string;
  companyName?: string;
  accentBorderColor?: string;
}

const FooterSection: React.FC<FooterProps> = ({
  primaryColor,
  accentColor,
  logoUrl,
  companyName,
  accentBorderColor = "#9a8348",
}) => {
  return (
    <div>
      <div
        style={{
          padding: "20px 20px 10px 20px",
          backgroundColor: primaryColor,
          background: primaryColor,
          color: "#fff",
          position: "relative",
          display: "flex",
          gap: "10px",
          flexDirection: "column",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <img src={logoUrl} alt="Company Logo" />
          </div>
          <a
            href="#top-nav"
            rel="noopener noreferrer"
            style={{
              padding: "10px",
              backgroundColor: accentColor,
              textDecoration: "none",
              border: "none",
              borderRadius: "50%",
              fontSize: "16px",
              cursor: "pointer",
              color: "#fff",
              width: "28px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "28px",
            }}
            className="scroll-to-top-button"
          >
            <ExpandLessOutlinedIcon style={{ fill: "white", color: "white" }} />
          </a>
        </div>
        <div
          style={{
            margin: "10px 0px 0px 0px ",
            borderTop: "1px solid ",
            borderColor: accentBorderColor,
            width: "100%",
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p>
            © {new Date().getFullYear()} {companyName} All rights reserved
          </p>
          <p>Privacy Policy</p>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
